import {
    trackTimesgridDataLoaded,
    trackProviderAvailabilityClickedClose,
    trackProviderAvailabilityClickedSearch,
    trackProviderAvailabilityTooltipRendered,
} from './actions';

export const mapDispatchToProps = {
    trackTimesgridDataLoaded,
    trackProviderAvailabilityClickedClose,
    trackProviderAvailabilityClickedSearch,
    trackProviderAvailabilityTooltipRendered,
};
